/** Reviewed demo/empty routes, kept in the CMS for later editorial completion. */
const UNPUBLISHED: Record<string, readonly string[]> = {
  'new.ktmbratislava.sk': ['/adam', '/novinky-1', '/faq'],
  'new.gasgas.sk': ['/adam', '/novinky-1', '/faq'],
  'new.cfmotobratislava.sk': ['/novinky-1', '/faq'],
};

export function isUnpublishedRsmotoPath(
  path: string,
  store = process.env.NEXT_PUBLIC_CURRENT_STORE ?? '',
) {
  if (!UNPUBLISHED[store]) return false;
  try {
    const url = new URL(path, `https://${store}`);
    if (url.hostname !== store) return false;
    return UNPUBLISHED[store].includes(url.pathname.replace(/\/$/, '') || '/');
  } catch {
    return false;
  }
}

export function publishedRsmotoMenuFields<T extends { path?: string | null }>(fields: T[]) {
  return fields.filter(field => !isUnpublishedRsmotoPath(field.path ?? ''));
}
